import { render, staticRenderFns } from "./CouponIndex2022_2.vue?vue&type=template&id=610b1d2c&scoped=true&"
import script from "./CouponIndex2022_2.vue?vue&type=script&lang=ts&"
export * from "./CouponIndex2022_2.vue?vue&type=script&lang=ts&"
import style0 from "./CouponIndex2022_2.vue?vue&type=style&index=0&id=610b1d2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b1d2c",
  null
  
)

export default component.exports